<template>
  <footer class="footBox">
    <div class="content-block">
      <h1>友情链接</h1>
      <el-row class="margin-b20">
        <el-col :span="3">
          <a class="a" href="https://developer.huawei.com" target="_blank">华为开放平台</a>
        </el-col>
        <el-col :span="3">
          <a class="a" href="https://open.oppomobile.com" target="_blank">OPPO开放平台</a>
        </el-col>
        <el-col :span="3">
          <a class="a" href="https://dev.vivo.com.cn/home" target="_blank">vivo开放平台</a>
        </el-col>
        <el-col :span="3">
          <a class="a" href="https://dev.mi.com" target="_blank">小米开放平台</a>
        </el-col>

     
      
      </el-row>
      <h1>联系我们</h1>
      <el-row>
        <!-- <el-col :span="3">
          官方微博
        </el-col> -->
        <el-col :span="3">
          <div class="codeHover">
            微信公众号
            <div class="codeImgBox">
              <img class="codeImg" src="@/assets/img/foot/codeImg.jpg" alt="微信公众号" />
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="codeHover">
            官方微信号
            <div class="codeImgBox">
              <img class="codeImg" src="@/assets/img/foot/code.jpg" alt="微信号" />
            </div>
          </div>
          
        </el-col>
        <el-col :span="6">
          邮箱 service@malink.cn   
        </el-col>
      </el-row>
      <hr class="hr">
    </div>
  </footer>
</template>

<script>
import { documentData } from "@/common/VO/homeVO.js";
export default {
  name: "foot",
  data() {
    return {
      documentData: documentData(),
    };
  },
  methods: {
    gotoService() {
      this.$router.push({
        path: "service",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.footBox {
  padding-top: 60px;
  color: $--color-text-regular;
  background-color: #F5F7FA;
  h1{
    font-size: 18px;
    margin-bottom: 20px;
  }
  .hr{
    margin-top: 30px;
  }
  .a {
    display: block;
    color: $--color-text-regular;
    &:hover {
      color: #2E84FC;
  
    }
  }
  .codeHover{
    text-align: left;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    .codeImgBox {
      position: absolute;
      display: none;
      top: -78px;
      right: -25%;
      z-index: 2;
      width: 116px;
      height: 108px;
      background: url("~@/assets/img/foot/codeImg.png") top no-repeat;
      .codeImg {
        position: absolute;
        left: 53%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 100px;
        height: 100px;
      }
    }
    &:hover {
      color: #333;
      text-decoration: underline;
      .codeImgBox {
        display: block;
      }
    }
  }
}
</style>
